import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_QUERY } from "./schema";

export const useDiscountLongTermForLongStayTermQuery = (hotelID: string, discountId: string) => {
	const { data } = useCustomSuspenseQuery(DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_QUERY, {
		variables: { hotelID, discountId },
		fetchPolicy: "no-cache",
	});

	return {
		discountLongTermForLongStayTermServerModel: data,
	};
};
